mutation UpdateKippahReminder($kippahReminder: Boolean!) {
  updateKippahReminder(kippahReminder: $kippahReminder) {
    ok
    errors
  }
}
